import React from 'react'
import { Card, CardBody, Button } from 'reactstrap'

import ReactGA from 'react-ga'

export const SignupPage = () => {

    return (
    <Card>
        <CardBody><CardBody>
            <div></div>
            <p>
              Sign up to take the JPTI Assessment&trade; and discover the job that fuels your passions and purpose.
            </p>
            <p>
                The JPTI&trade; is the only assessment available that's capable of identifying the kind of work
                that you can feel deeply passionate about doing.
            </p>
            <div className="text-center" style={{marginTop: "20px"}}>
                <ReactGA.OutboundLink
                    eventLabel="sign_up"
                    to="https://careerzgroup.com/career-assessments/job-passion-type-indicator-JPTI/"
                    target="_blank"
                ><Button color="primary">LEARN MORE</Button></ReactGA.OutboundLink>
            </div>
        </CardBody></CardBody>
    </Card>
    )
}